import { render, staticRenderFns } from "./UpdateShippedDialog.vue?vue&type=template&id=d0df4944&scoped=true&lang=pug&"
import script from "./UpdateShippedDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateShippedDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0df4944",
  null
  
)

export default component.exports